import Vue from "vue";
import i18n from "../../../i18n";

export default {
  async fetchRankList({ commit }) {
    let res = await Vue.axios.get(Vue.$url("rank"));
    commit("SET_RANKLIST", res.data);
  },
  async deleteRankList(_, ranklist) {
    await Vue.axios.delete(Vue.$url("rank/" + ranklist.id), { id: ranklist.id, ranking: ranklist.ranking });
  },
  async updateRankList(_, ranklist) {
    console.log(ranklist);
    await Vue.axios.put(Vue.$url("rank/" + ranklist.id), ranklist);
  },
  async createRankList(_, ranklist) {
    await Vue.axios.post(Vue.$url("rank"), ranklist);
  },

  async updateRanklistList({ commit }, payload) {
    Vue.$log.debug("Update xlsx", payload);

    let formData = new FormData();
    formData.append("file", payload.file);
    formData.append("resetOldValues", payload.resetOldValues);

    return await Vue.axios
      .post(Vue.$url(`rank/import`), formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((rsp) => {
        commit("mShowInfoMessage", i18n.t("common.upload"), { root: true });
        return rsp.data;
      });
  },
};
